<template>
  <SbsFullWidthLayout>
    <SubscriptionContent />
  </SbsFullWidthLayout>
</template>

<script lang="ts" setup>
import SbsFullWidthLayout from '@/components/snowflake/SbsFullWidthLayout.component.vue';
import SubscriptionContent from '@/components/SubscriptionContent.component.vue';
</script>
